import { EyeOutlined, EditOutlined, SearchOutlined, PrinterOutlined ,CloseCircleOutlined} from "@ant-design/icons";
import { Row, Col, Button, Form, Input, Space, Table, Modal, Divider } from "antd";  // Import Modal here

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import enrollmentService from "../../../api/enrollment.service";
import { SUCCESS_STATUS } from "../../../utility/Constants";
import ProgrammeService from "../../../api/programme.service";
import CustomTableSearch from "../../common/CustomTableSearch";
import commonUtility from "../../../utility/Utils";
import { PRINT_BASE_URL } from "../../../utility/URL";
import { Link } from "react-router-dom";

const JcpReceiptList = () => {
  let navigate = useNavigate();

  const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
  const [page, setPage] = React.useState(1);
  const [selectedProgramme, setSelectedProgramme] = useState(0);
  const [jcpEnrollmentReceiptList, setJcpEnrollmentReceiptList] = useState([]);
  const [filteredSearchList, setFilteredSearchList] = useState([]);

  // Modal states
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const pageSize = 10;
  const pagination = { current: page, pageSize };

  const columns = [
    {
      title: '#',
      dataIndex: 'index',
      render: (text, record, index) => (pagination.current - 1) * pagination.pageSize + index + 1,
      width: '5%',
    },
    {
      title: 'Receipt',
      dataIndex: 'receipt_no',
      key: 'receipt_no',
    },
    {
      title: 'Date',
      dataIndex: 'receipt_date',
      key: 'receipt_date',
    },
    {
      title: 'Shift',
      dataIndex: 'programme_group',
      key: 'programme_group',
    },
    {
      title: 'Name',
      dataIndex: 'member_fname',
      key: 'member_fname',
      sorter: (a, b) => {
        const nameA = `${a.member_fname} ${a.member_lname}`;
        const nameB = `${b.member_fname} ${b.member_lname}`;
        return nameA.localeCompare(nameB);
      },
      render: (selectedObj, record) => (
        <Space>
          <span>{record.member_fname} {record.member_lname}</span>
        </Space>
      ),
    },
    {
      title: 'Mobile',
      dataIndex: 'primary_mobile',
      key: 'primary_mobile',
    },
    {
      title: 'DOB',
      dataIndex: 'date_of_birth',
      key: 'date_of_birth',
    },
    // {
    //   title: 'Description',
    //   dataIndex: 'description_list',
    //   key: 'description_list',
    // },
    // {
    //   title: 'Validity',
    //   dataIndex: 'enrollment_start_date',
    //   key: 'enrollment_start_date',
    //   sorter: (a, b) => {
    //     const nameA = `${a.enrollment_start_date} ${a.enrollment_end_date}`;
    //     const nameB = `${b.enrollment_start_date} ${b.enrollment_end_date}`;
    //     return nameA.localeCompare(nameB);
    //   },
    //   render: (selectedObj,record) => (
    //     <Space>
    //         <span>{record.enrollment_start_date} to {record.enrollment_end_date}</span>
    //     </Space>
    //   ),
    // },
    {
      title: 'Payable',
      dataIndex: 'net_payble_amount',
      key: 'net_payble_amount',
      align: 'right',
      render: (selectedObj, values) => (
        <div align="right">{commonUtility.sanitizeValue(values.total_payble_amount).toFixed(2)} </div>
      )
    },
    {
      title: 'Payment',
      dataIndex: 'net_payble_amount',
      key: 'net_payble_amount',
      align: 'right',
      render: (selectedObj, values) => (
        <div align="right">{commonUtility.sanitizeValue(values.payment_amount).toFixed(2)} </div>
      )
    },
    {
      title: 'Action',
      key: 'action',
      render: (selectedObj) => (
        <Space style={{ display: 'flex', flexDirection: 'column' }}>
          {!(selectedObj.is_active === 'N' && selectedObj.is_cancel === 'Y') ? (
            <>
              <Button
                htmlType="button"
                type="ghost"
                size="small"
                shape="round"
                className="custombutton-type1"
                style={{ width: 90, backgroundColor: "#4CAF50", color: "white" }}
                onClick={() => showModal(selectedObj)}  // Open modal on View click
              >
                <EyeOutlined /> View
              </Button>

              <Link to={`/enrollment-jcp/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}`} >
                <Button htmlType="button" type="ghost" size="small" shape="round" className="custombutton-type1" style={{ width: 90 }} ><EditOutlined /> Edit</Button>
              </Link>

              <a href={`${PRINT_BASE_URL}taxinvoice/receiptpdf/${selectedObj.enrollment_id}/${selectedObj.receipt_id}/${selectedObj.payment_id}/${commonUtility.getLoggedInUserInfo()?.companyID > 0 ? commonUtility.getLoggedInUserInfo()?.companyID : 0}`} target="_blank" rel="noopener noreferrer">
                <Button htmlType="button" type="ghost" size="small" shape="round" type="primary" style={{ width: 90 }}><PrinterOutlined /> Print</Button>
              </a>
            </>
          ) : (
            <Button
              htmlType="button"
              type="ghost"
              size="small"
              shape="round"
              className="custombutton-type1"
              style={{ width: 100, backgroundColor: "#F44336", color: "white" ,fontSize:12 ,textAlign:"center" }}
              onClick={() => showModal(selectedObj)}  // Open modal on View click
            >
              <CloseCircleOutlined /> Cancelled
            </Button>
          )}
        </Space>
      ),
    },
  ];

  const showModal = (record) => {
    setSelectedData(record);  // Set the data for the modal
    setIsModalVisible(true);   // Open the modal
  };

  const handleOk = () => {
    setIsModalVisible(false);  // Close the modal
  };

  const handleCancel = () => {
    setIsModalVisible(false);  // Close the modal
  };

  useEffect(() => {
    const data = { formdata: { short_code: "JCP" } };
    ProgrammeService.programmeByCode(data).then((res) => {
      if (res.data.response_status === SUCCESS_STATUS) {
        setSelectedProgramme(res.data.response_data[0].programme_id);
      }
    });
  }, []);

  useEffect(() => {
    const data = { formdata: { programme_id: selectedProgramme } };
    enrollmentService.receiptListJCP(data).then((res) => {
      setJcpEnrollmentReceiptList(res.data.response_data);
      setFilteredSearchList(res.data.response_data);
    });
  }, [selectedProgramme]);

  const onSearch = (e) => {
    setFilteredSearchList([]);
    const string = e.target.value;
    const x = jcpEnrollmentReceiptList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
    setFilteredSearchList(x);
  };

  return (
    <>
      <CustomTableSearch onSearchTable={onSearch} style={{ marginBottom: "8px" }} />

      <Table
        columns={columns}
        rowKey='receipt_id'
        dataSource={filteredSearchList}
        pagination={{
          current: page,
          pageSize,
          total: filteredSearchList.length,
          onChange: (page) => setPage(page),
        }}
      />

      {/* Modal for View */}


      <Modal
        title={null}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={false}
        width={450} // Reduced width for compact view
        centered // Keeps the modal centered on the screen
        style={{
          borderRadius: '10px',
          fontFamily: 'Arial, sans-serif',
        }}
      >
        {selectedData && (
          <div>
            <div
              style={{
                background: '#F8F8F8',
                padding: '10px',
                borderRadius: '20px',
              }}
            >
              {/* Header */}
              <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                <h2 style={{ fontWeight: 'bold', color: "#685211" }}>Receipt Details</h2>
                <p style={{ fontSize: '11px', color: '#888' }}>
                  {selectedData.bill_type}
                </p>
              </div>

              {/* Payment No */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'white',
                  padding: '6px 10px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <span style={{ fontWeight: 'bold' }}>Receipt No:</span>
                <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                  {selectedData.payment_no}
                </span>
              </div>


              {/* Member Name */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'white',
                  padding: '8px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <p style={{ marginBottom: '4px' }}><strong>Member Name:</strong></p>
                <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                  {selectedData.member_fname} {selectedData.member_lname}
                </span>
              </div>

              {/* Payment Date */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'white',
                  padding: '8px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <p style={{ marginBottom: '4px' }}><strong>Payment Date:</strong></p>
                <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                  {selectedData.payment_date ?
                    new Date(selectedData.payment_date).toLocaleDateString('en-GB', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                    }) : ''}
                </span>
              </div>


              {/* Payment Details */}
              <div
                style={{
                  background: 'white',
                  padding: '8px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <Row style={{ marginBottom: '4px' }}>
                  <Col span={12}><strong>Payable Amt:</strong></Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    ₹{commonUtility.sanitizeValue(selectedData.total_payble_amount).toFixed(2)}
                  </Col>
                </Row>
                <Row>
                  <Col span={12}><strong>Payment Amt:</strong></Col>
                  <Col span={12} style={{ textAlign: 'right' }}>
                    ₹{commonUtility.sanitizeValue(selectedData.payment_amount).toFixed(2)}
                  </Col>
                </Row>
              </div>


              {/* Shift */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'white',
                  padding: '8px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <p style={{ marginBottom: '4px' }}><strong>Shift:</strong></p>
                <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                  {selectedData.programme_group}
                </span>
              </div>


              {/* Validity */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'white',
                  padding: '8px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <p style={{ marginBottom: '4px' }}><strong>Validity:</strong></p>
                <div>
                  <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                    {selectedData.enrollment_start_date ?
                      new Date(selectedData.enrollment_start_date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      }) : ''}
                  </span>
                  <span> - </span>
                  <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                    {selectedData.enrollment_end_date ?
                      new Date(selectedData.enrollment_end_date).toLocaleDateString('en-GB', {
                        day: '2-digit',
                        month: 'short',
                        year: 'numeric',
                      }) : ''}
                  </span>
                </div>
              </div>

              {/* Description */}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  background: 'white',
                  padding: '8px',
                  borderRadius: '5px',
                  marginBottom: '8px',
                  fontSize: '11px',
                  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                }}
              >
                <p style={{ marginBottom: '4px' }}><strong>Description:</strong></p>
                <span style={{ background: '#f7ebbf', padding: '4px 6px', borderRadius: '4px' }}>
                  {selectedData.description_list}
                </span>
              </div>
            </div>
            {/* Close Button */}

            <div style={{ textAlign: "right", marginTop: "10px" }}>
              <Button type="danger" onClick={handleCancel} style={{ borderRadius: "5px" }}>
                Close
              </Button>
            </div>
          </div>
        )}
      </Modal>

    </>
  );
};

export default JcpReceiptList;
